<div class="flex justify-between items-center pb-2">
  <span class="text-lg font-bold text-gray-900">{{
    intervention().subType | translateConstant: constantService.foodSafety
  }}</span>
  <div class="flex items-baseline gap-1 text-gray-600">
    <i class="pi pi-calendar"></i>
    <span
      class="text-m font-normal"
      [aoDateWeekNumber]="intervention().foodSafety?.completedDate"
    ></span>
  </div>
</div>
@if (intervention().subType === interventionFoodSafetyTypes.REVIEW_APPLIED_BUFFER) {
  <div class="pt-2 pb-2 border-t border-gray-300 flex justify-between">
    <span>{{ intervention().foodSafety?.bufferZone }} {{ intervention().foodSafety?.bufferZoneUnit }}</span>
    @if (intervention().foodSafety?.location; as location) {
      <bnd-button
        shape="circle"
        size="sm"
        color="primary"
        mode="ghost"
        (click)="openMaps(location)"
        [attr.data-testid]="'open-map'"
      >
        <i class="pi pi-map-marker"></i>
      </bnd-button>
    }
  </div>
}
@if (intervention().note?.length) {
  <div class="mt-1.5 text-sm">
    {{ intervention().note }}
  </div>
}
